import { store } from "../../../redux/store"


export const getAccessTypes = () => {

    const state = store.getState()
    const loggedInUser = state?.auth?.authenticatedUserSlice?.loggedInUserDetails

    /**
     [
    {
        "roleId": "f49f7717-5bae-4ba4-b069-1fa1502ee88e",
        "role": "A2 - Client Account Admin",
        "groupName": "G3"
    },
    {
        "roleId": "82511c17-b73c-4b9f-b0b2-2794c8425ca9",
        "role": "A1 - Super Admin - Client Portal",
        "groupName": "G3"
    },
    {
        "roleId": "94564334-a8fb-4431-a758-9ee95ddb9908",
        "role": "A3 - Client Sub-Account Admin",
        "groupName": "G3"
    },
    {
        "roleId": "a88ae2de-3145-4ec5-9bec-28156ab8ec7d",
        "role": "Admin",
        "groupName": "G2"
    },
    {
        "roleId": "4ef0de15-50ce-4d09-8931-2cbf13625282",
        "role": "Enterprise Admin",
        "groupName": "G1"
    },
    {
        "roleId": "c4876d2c-13a8-4dfd-b58b-34bdacacf5d6",
        "role": "Super Admin",
        "groupName": "G2"
    },
    {
        "roleId": "e1ae1bfe-ae3c-482b-932b-693c95cd113c",
        "role": "Coach",
        "groupName": "G2"
    },
    {
        "roleId": "4b74544d-6023-4375-b8bb-d6b39f787dce",
        "role": "Coach Admin",
        "groupName": "G2"
    }
]
     */
    /**enterprise admin access */
    let isEnterpriseAdmin = false

    /**candidate portal access */
    let isCandidatePortalAdmin = false
    let hasAdminAccess = false
    let hasSuperAdminAccess = false
    let hasCoachAccess = false
    let hasCoachAdminAccess = false

    /**client portal access */
    let isClientPortalAdmin = false
    let hasA1Access = false
    let hasA2Access = false
    let hasA3Access = false
    let hasA4Access = false


    // const candidatePortalAdminRegEx = /Super Admin|Admin|Coach|Coach Admin/
    const enterpriseAdminRegEx = /4ef0de15-50ce-4d09-8931-2cbf13625282/

    const candidatePortalAdminRegEx = /c4876d2c-13a8-4dfd-b58b-34bdacacf5d6|e1ae1bfe-ae3c-482b-932b-693c95cd113c|4b74544d-6023-4375-b8bb-d6b39f787dce|a88ae2de-3145-4ec5-9bec-28156ab8ec7d/

    // const clientPortalAdminRegEx = /A1|A2|A3/
    const clientPortalAdminRegEx = /f49f7717-5bae-4ba4-b069-1fa1502ee88e|82511c17-b73c-4b9f-b0b2-2794c8425ca9|94564334-a8fb-4431-a758-9ee95ddb9908|9f5b89c1-e57b-4ea1-a2cd-8d481a626ee8/


    if (!!loggedInUser?.id) {
        const roleId = loggedInUser?.role?.role?.roleId || ""
        const clientPortalAdminRoleId = loggedInUser?.clientPortalAdminRoleId || ""

        if (roleId.search(enterpriseAdminRegEx) !== -1) {
            isEnterpriseAdmin = true

            isCandidatePortalAdmin = false
            isClientPortalAdmin = false

            hasSuperAdminAccess = false
            hasAdminAccess = false
            hasCoachAccess = false
            hasCoachAdminAccess = false

            hasA1Access = false
            hasA2Access = false
            hasA3Access = false
        } else {
            /**candidate portal access */
            // console.log("candidatePortalAdminRegEx", roleId.search(candidatePortalAdminRegEx))

            if (roleId.search(candidatePortalAdminRegEx) !== -1) {
                isCandidatePortalAdmin = true

                const superAdminRegex = /c4876d2c-13a8-4dfd-b58b-34bdacacf5d6/
                const adminRegex = /a88ae2de-3145-4ec5-9bec-28156ab8ec7d/
                const coachRegex = /e1ae1bfe-ae3c-482b-932b-693c95cd113c/
                const coachAdminRegex = /4b74544d-6023-4375-b8bb-d6b39f787dce/

                if (roleId.search(superAdminRegex) !== -1) {
                    hasSuperAdminAccess = true
                    hasAdminAccess = false
                    hasCoachAccess = false
                    hasCoachAdminAccess = false

                } else if (roleId.search(adminRegex) !== -1) {

                    hasSuperAdminAccess = false
                    hasAdminAccess = true
                    hasCoachAccess = false
                    hasCoachAdminAccess = false

                } else if (roleId.search(coachRegex) !== -1) {

                    hasSuperAdminAccess = false
                    hasAdminAccess = false
                    hasCoachAccess = true
                    hasCoachAdminAccess = false

                } else if (roleId.search(coachAdminRegex) !== -1) {

                    hasSuperAdminAccess = false
                    hasAdminAccess = false
                    hasCoachAccess = false
                    hasCoachAdminAccess = true
                }
            }

            /**client portal access */
            if (clientPortalAdminRoleId.search(clientPortalAdminRegEx) !== -1) {
                const a1Regex = /82511c17-b73c-4b9f-b0b2-2794c8425ca9/ //A1
                const a2Regex = /f49f7717-5bae-4ba4-b069-1fa1502ee88e/ //A2
                const a3Regex = /94564334-a8fb-4431-a758-9ee95ddb9908/ //A3
                const a4Regex = /9f5b89c1-e57b-4ea1-a2cd-8d481a626ee8/ //A4

                isClientPortalAdmin = true
                if (clientPortalAdminRoleId.search(a1Regex) !== -1) {
                    hasA1Access = true
                    hasA2Access = false
                    hasA3Access = false
                    hasA4Access = false
                } else if (clientPortalAdminRoleId.search(a2Regex) !== -1) {

                    hasA1Access = false
                    hasA2Access = true
                    hasA3Access = false
                    hasA4Access = false
                } else if (clientPortalAdminRoleId.search(a3Regex) !== -1) {

                    hasA1Access = false
                    hasA2Access = false
                    hasA3Access = true
                    hasA4Access = false
                } else if (clientPortalAdminRoleId.search(a4Regex) !== -1) {

                    hasA1Access = false
                    hasA2Access = false
                    hasA3Access = false
                    hasA4Access = true
                }
            }
        }
    }


    return {
        isEnterpriseAdmin,
        candidatePortalAdminType: {
            isCandidatePortalAdmin,
            hasSuperAdminAccess,
            hasAdminAccess,
            hasCoachAccess,
            hasCoachAdminAccess,
        },
        clientPortalAdminType: {
            isClientPortalAdmin,
            hasA1Access,
            hasA2Access,
            hasA3Access,
            hasA4Access,
        }
    }
}